"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.782 2.218a.745.745 0 0 1 0 1.054l-14.51 14.51a.745.745 0 1 1-1.054-1.054l14.51-14.51a.745.745 0 0 1 1.054 0M3.29 4.638c.424-.914 1.367-1.595 2.567-1.595h7.294a.696.696 0 1 1 0 1.392H5.857c-.644 0-1.102.352-1.305.789-.2.431-.158.95.25 1.365l2.752 2.795a.696.696 0 1 1-.992.976L3.811 7.565a2.57 2.57 0 0 1-.521-2.927m8.295 6.432c.385 0 .696.312.696.696v3.004c0 1.247-1.062 2.186-2.28 2.186-1.219 0-2.28-.94-2.28-2.186a.696.696 0 1 1 1.39 0c0 .4.358.795.89.795.531 0 .889-.395.889-.795v-3.004c0-.384.311-.696.695-.696",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilterOffIcon20.js.map